export default __webpack_public_path__ + "static/media/search-gray.2cfaa5bd.svg";